<template>
    <div>
        <!-- summary block -->
        <div
            class="order-result-summary"
            v-if="(mode === 'business' && mondayDelivery) || (mode==='private' && privateDeliveryDay === 'monday')"
        >
            <div class="order-result-summary__col">
                <div class="order-result-summary__text-container text-container">
                    <h4>Montagslieferung</h4>
                    <p>{{ interval('monday').name }}</p>
                </div>
            </div>
            <div class="order-result-summary__col">
                <div class="order-result-summary__baskets__list">
                    <div
                        v-for="(basket, index) in sortedBasketsMonday"
                        :key="`monday-basket-${index}`"
                        class="order-result-summary__weight-container"
                    >
                        <span class="order-result-summary__weight-text">
                            {{ basket.kg }} kg
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <!-- summary block -->
        <div
            class="order-result-summary"
            v-if="wednesdayDelivery"
        >
            <div class="order-result-summary__col">
                <div class="order-result-summary__text-container text-container">
                    <h4>Mittwochslieferung</h4>
                    <p>{{ interval('wednesday').name }}</p>
                </div>
            </div>
            <div class="order-result-summary__col">
                <div class="order-result-summary__baskets__list">
                    <div
                        v-for="(basket, index) in sortedBbasketsWednesday"
                        :key="`wednesday-basket-${index}`"
                        class="order-result-summary__weight-container"
                    >
                        <span class="order-result-summary__weight-text">
                            {{ basket.kg }} kg
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import { mapState, mapGetters } from 'vuex';

import priceMixin from '../mixins/priceMixin';

export default {
    mixins: [
        priceMixin,
    ],
    computed: {
        ...mapState({
            mode: state => state.mode,
            privateDeliveryDay: state => state.privateDeliveryDay,
            intervals: state => state.intervals,
            orderableIntervals: state => state.orderable.intervals,
        }),
        ...mapGetters([
            'amounts',
            'appetites',
            'orderableBaskets',
            'groupedBaskets',
            'allBaskets',
            'sortedBasketsMonday',
            'sortedBbasketsWednesday',
        ]),
        mondayDelivery() {
            return this.sortedBasketsMonday.length;
        },
        wednesdayDelivery() {
            return this.sortedBbasketsWednesday.length;
        },
    },
    methods: {
    },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// ResultsSummary.vue?1492f0fa